<template>
  <div class="links" style="text-align: left">
  <div class="linksList" style="padding: 10px">
    <div v-for="(info, index) in linkInfo" :key="index">
      <p class="names">{{ info['head'] }}</p>
      <ul class="clear">
        <li class="linksList-li" v-for="(l, i) in info.list" :key="i">
          <a target="_blank" :href="l.link">{{ l['name'] }}</a>
        </li>
      </ul>
    </div>
  </div>
  </div>
</template>

<script>

export default {
  name: 'LinksPc',
  props: ['linkInfo'],
  data () {
    return {
      infos: [
        {
          head: 'Total Synthesis Highlights by LiJian Club',
          list: [
            {
              name: 'Lab Home',
              link: '/'
            }
          ]
        },
        {
          head: 'University',
          list: [
            {
              name: 'University',
              link: 'https://www.nwsuaf.edu.cn/'
            },
            {
              name: '林学院',
              link: 'https://cf.nwafu.edu.cn/'
            },
            {
              name: '植物保护学院',
              link: 'https://ppc.nwafu.edu.cn/'
            },
            {
              name: 'Mall',
              link: 'http://webmail.nwsuaf.edu.cn/'
            }
          ]
        },
        {
          head: 'Data Bases',
          list: [
            {
              name: 'SciFinder',
              link: 'https://www.cas.org/products/scifinder'
            },
            {
              name: 'Pubmed',
              link: 'https://pubmed.ncbi.nlm.nih.gov/'
            },
            {
              name: 'Web of Science',
              link: 'https://www.webofscience.com/wos/alldb/basic-search'
            }
          ]
        },
        {
          head: 'Total Synthesis',
          list: [
            {
              name: 'Chemistry by Design',
              link: 'http://www.dengjunclub.com/article/115'
            },
            {
              name: 'SynAchive',
              link: 'http://www.dengjunclub.com/article/14'
            },
            {
              name: 'Total Syn A-Z',
              link: 'http://www.dengjunclub.com/article/13'
            },
            {
              name: 'Total Synthesis Highlights',
              link: 'http://www.dengjunclub.com/article/12'
            }
          ]
        },
        {
          head: 'Resource',
          list: [
            {
              name: 'X-Mol',
              link: 'http://www.dengjunclub.com/article/19'
            },
            {
              name: 'Muchong',
              link: 'http://www.dengjunclub.com/article/18'
            },
            {
              name: 'Chemical Book',
              link: 'http://www.dengjunclub.com/article/17'
            },
            {
              name: 'Chem-Station',
              link: 'http://www.dengjunclub.com/article/16'
            },
            {
              name: 'Bordwell pKa Table',
              link: 'http://www.dengjunclub.com/article/15'
            },
            {
              name: 'Top Pharmaceuticals Poster',
              link: 'http://www.dengjunclub.com/article/138'
            }
          ]
        },
        // {
        //   head: 'Denksport',
        //   list: [
        //     {
        //       name: 'Fukuyama',
        //       link: 'http://www.dengjunclub.com/article/22'
        //     },
        //     {
        //       name: 'Yokoshima',
        //       link: 'http://www.dengjunclub.com/article/21'
        //     },
        //     {
        //       name: 'Trauner',
        //       link: 'http://www.dengjunclub.com/article/20'
        //     }
        //   ]
        // },
        {
          head: 'Special Recommendation',
          list: [
            {
              name: '南京林业大学',
              link: 'https://www.njfu.edu.cn/'
            },
            {
              name: '北京林业大学',
              link: 'http://www.bjfu.edu.cn/'
            },
            {
              name: '中南林业大学',
              link: 'https://www.csuft.edu.cn/'
            },
            {
              name: '中国林业科学研究院林产化学工业研究所',
              link: 'http://icifp.caf.ac.cn/'
            }
          ]
        }
      ]
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/views/links/LinksPc.vue